import type { PayPalCheckoutCreatePaymentOptions } from 'braintree-web/paypal-checkout';
import type { LineItem } from '../../typings/payPal.types';
import { ItemKind } from '../../typings/payPal.types';

/** Ambient paypal.* enums have no runtime object — keep string values typed once here. */
const PAYPAL_INTENT_AUTHORIZE = 'authorize' as paypal.Intent;
const PAYPAL_FLOW_CHECKOUT = 'checkout' as paypal.FlowType;

const toPaypalLineItemKind = (kind: ItemKind): paypal.LineItemKind =>
    kind === ItemKind.CREDIT ? ('credit' as paypal.LineItemKind) : ('debit' as paypal.LineItemKind);

/**
 * Maps app line items to Braintree/PayPal SDK line items (string amounts and quantities).
 */
export const toPaypalLineItems = (lineItems: LineItem[]): paypal.LineItem[] =>
    lineItems.map((item) => ({
        name: item.name,
        quantity: String(item.quantity),
        unitAmount: String(item.unitAmount),
        kind: toPaypalLineItemKind(item.kind),
        unitTaxAmount: undefined,
        description: undefined,
        productCode: undefined,
        url: undefined,
    }));

export const buildCreatePaymentOptions = ({
    amount,
    currency,
    lineItems,
}: {
    amount: string;
    currency: string;
    lineItems: LineItem[];
}): PayPalCheckoutCreatePaymentOptions => ({
    intent: PAYPAL_INTENT_AUTHORIZE,
    flow: PAYPAL_FLOW_CHECKOUT,
    amount,
    currency,
    enableShippingAddress: true,
    shippingAddressEditable: true,
    lineItems: toPaypalLineItems(lineItems),
});
